export const personalData = {
 id: 0,
 name: 'Raul',
 lastnames: 'Saldarriaga Atencio',
 cargo: 'Consultor',
 email: 'RaulsaldarriagaA@gmail.com',
 phone: '+573218352201',
 private: false,
 badge: {
  type: 'success',
  content: '2.1%',
  icon: 'caret-up'
 }
};

export const assignmentScores = [
 {
  id: 0,
  name: 'Proyectos',
  range: '90-100%',

  color: 'success',
  badge: {
   type: 'success',
   content: '2.1%',
   icon: 'caret-up'
  }
 },
 {
  id: 1,
  name: 'Separaciones',
  range: '70-90%',
  mount: 160,
  color: 'primary',
  badge: {
   type: 'danger',
   content: '5.1%',
   icon: 'caret-down'
  }
 },
 {
  id: 2,
  name: 'Cuotas Iniciales',
  range: '40-70%',
  mount: 32,
  color: 'info',
  badge: {
   type: 'secondary',
   content: '0.0%'
  }
 },
 {
  id: 3,
  name: 'Financiaciones',
  range: '0-40%',
  mount: 20,
  color: 'warning',
  badge: {
   type: 'primary',
   content: '3.5%',
   icon: 'plus'
  }
 }
];

export const spendingsData = [85, 60, 120, 70, 100, 15, 65, 80, 60, 75, 45];

export const timeOnSiteData = [55, 60, 40, 120, 70, 80, 35, 80, 85];
